import { NotificationMessage } from 'src/models/notification.model';

export function convertMessage(message: NotificationMessage) {
  return { ...message, created_at: new Date(message.created_at) };
}
